import { FeePackage, FeePackagesResponse } from '../stores/types/feePackage.interface';
import { API_KEYS, Api } from './base.api';
import { SCOPE_TYPE } from './utils';

export const feePackagesApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchFeePackage: builder.query<FeePackage, { flexPlanId: string }>({
      query: ({ flexPlanId }) => ({
        url: `/internal/core/v1/${API_KEYS.FEE_PACKAGES}/${flexPlanId}`,
        method: 'GET',
        needCompanyId: false,
        params: {
          scope: SCOPE_TYPE.NONE,
        },
      }),
    }),
    fetchFeePackagesByName: builder.query<FeePackagesResponse, { name: string }>({
      query: ({ name }) => ({
        url: `/internal/core/v1/${API_KEYS.FEE_PACKAGES}`,
        method: 'GET',
        needCompanyId: false,
        params: {
          'filter_eq[name]': name,
          scope: SCOPE_TYPE.NONE,
        },
      }),
    }),
  }),
});

export const {
  useFetchFeePackageQuery,
  useLazyFetchFeePackageQuery,
  useFetchFeePackagesByNameQuery,
  useLazyFetchFeePackagesByNameQuery,
} = feePackagesApi;
